import React from 'react';

import { Box } from '@rbilabs/universal-components';
import { TWELVE_HOUR_TIME_PARSE_FORMAT } from 'features/store/constants';
import { readableHour } from 'features/store/utils';
import { Typography } from 'ucl/components/text/Typography';

import { IServerOrder } from '@rbi-ctg/menu';
import useOrderNumber from 'hooks/use-order-number';
import { t } from 'state/intl/translations';
import { getConfigValue } from 'utils/environment';

import { CardHeading, CardHeadingContainer, CardText } from '../styled';

interface IDeliveryOrderDetails {
  serverOrder: IServerOrder;
}

const DeliveryOrderDetails = ({ serverOrder }: IDeliveryOrderDetails) => {
  const orderNumber = useOrderNumber(serverOrder);
  const cardType = serverOrder?.cart?.payment?.cardType || null;
  const ccLast4 = serverOrder?.cart?.payment?.ccLast4 || null;

  const timeFormatConfig = getConfigValue({
    key: 'timeFormat',
    defaultValue: TWELVE_HOUR_TIME_PARSE_FORMAT,
  });

  const isCashApp = cardType === 'CASHAPP';

  return (
    <CardHeadingContainer>
      <CardHeading>{t('orderDetailsHeading')}</CardHeading>

      <Box marginTop="$4">
        {orderNumber ? (
          <CardText>
            <Typography bold>{t('orderNumber')}: </Typography>
            {orderNumber}
          </CardText>
        ) : null}
        {cardType && ccLast4 && !isCashApp && (
          <CardText>
            <Typography bold>{t('payment')}: </Typography>
            {t('paymentXEndingInY', {
              cardType,
              ccLast4,
            })}
          </CardText>
        )}
        {isCashApp && (
          <CardText>
            <Typography bold>{t('payment')}: </Typography>
            {t('cashAppPay')}
          </CardText>
        )}
        <CardText>
          <Typography bold>{t('orderTime')}: </Typography>
          {readableHour({
            timeISOString: serverOrder.createdAt,
            timeFormat: timeFormatConfig,
          })}
        </CardText>
      </Box>
    </CardHeadingContainer>
  );
};

export default DeliveryOrderDetails;
